import { Link } from 'react-router-dom';

function NotFoundPage() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6 text-center">
            <div className="max-w-md">
                <p className="text-3xl font-medium text-gray-400 mb-1">404</p>
                <h1 className="text-xl font-semibold text-gray-800 mb-2">Page not found</h1>
                <p className="text-sm text-gray-500 mb-6">
                    The page you are looking for does not exist, or the link may be incorrect.
                </p>
                <Link
                    to="/"
                    className="inline-block px-5 py-2 rounded-md bg-[#2563EB] text-white text-sm font-medium hover:bg-[#1d4ed8] transition"
                >
                    Go to home
                </Link>
            </div>
        </div>
    );
}

export default NotFoundPage;
